const bytesToMegaBytes = (bytes, roundTo) => {
  const sizeMB = roundTo
    ? (bytes / (1024 * 1024)).toFixed(roundTo)
    : bytes / (1024 * 1024);
  return sizeMB;
};

export default bytesToMegaBytes;
